var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"footer_box"},[_c('div',[_vm._v("Copyright © 2024 苏州来吧科技有限公司 版权所有 "),_c('br'),_c('a',{attrs:{"target":"_blank","href":"https://beian.miit.gov.cn"}},[_c('div',[_vm._v("苏ICP备2024094573号-2A")])])])])
}]

export { render, staticRenderFns }